const quinceSortCodePattern = /^[A-Z]{3,8}_[A-Z]+_[A-Z]{3}[0-9]+$/;

export function isQuinceSortCode(sortCode: string | undefined): boolean {
  if (!sortCode) {
    return false;
  }
  return quinceSortCodePattern.test(sortCode);
}
